import React, {
  useRef,
  useEffect,
  useMemo,
  useContext,
  createContext,  
} from 'react';

import createStyle from 'shared-utils/src/createStyle';

import Grid from '../Grid';

import Strip from './components/Strip';
import Gallery from './components/Gallery';
import GalleryPlaceholder from './components/GalleryPlaceholder';
import Details from './components/Details';
import Units from './components/Units';

import { depthMap } from './utils';

import styles, { mainCls } from './style';

export const CardContext = createContext();
export const useCardContext = () => useContext(CardContext);

const useStyles = createStyle(styles);

export default function SrpCard({
  id,
  depth,
  highlight,
  poi,
  media,
  labels,
  title,
  isAuction,
  features,
  isProjectProfile,
  projectData,
  description,
  publisher,
  units,
  saved,
  visible,
  setRef,
  isSixth,
  collapseMandateBanner,
  isFetching,
  uri,
  actions,
  showMortgage,
  showMqPrice,
  category,
  vWidth,
  iosLth12,
  createFloorplanModal,
  openModal,
  setCurrentFloorplan,
  sendMail,
  propertyTypeGroup,
  geoInfos: {
    geo_visibility_level: geoVisibilityLevel = 3,
  } = {},
  maplist = false,
  mapcard = false,
  forceVisible,
  isMobile,
}) {
  const cls = useStyles();

  const el = useRef(null);

  const safeDepthValue = depth
    ? depth.replace('-project', '')
    : 'standard';

  const depthInfos = depthMap[safeDepthValue];

  useEffect(() => {
    setRef(el.current);
  }, [el, setRef]);

  useEffect(() => {
    if (isSixth && visible && collapseMandateBanner) {
      collapseMandateBanner();
    }
  }, [isSixth, visible]);

  const distancePoiStrip = () => {
    if (geoVisibilityLevel === 1) {
      return (
        <>
          a <span className="tp-w--l">{poi.distance}m</span> dalla {poi.type === 'subway' ? 'metro ' : ''}<span className="tp-w--l">{poi.name}</span>
        </>
      ) 
    }
    return (
      <>
        entro <span className="tp-w--l">{poi.distance}m</span> da {poi.type === 'supermarket' ? 'un ' : 'una '}<span className="tp-w--l">{poi.category}</span>
      </>
    )
  }

  const cardContextValue = useMemo(() => ({ maplist, mapcard }), [maplist, mapcard]);
  const isHoliday = ['vacanze', 'case-vacanza'].includes(category) || ['vacanze', 'case-vacanza'].includes(propertyTypeGroup);

  return (
    <div ref={el} className={`${cls[`${mainCls}__cnt-card`]}${mapcard ? ' forMapcard' : ''} is-rel`}>
      <div className={cls[`${mainCls}__anchor`]} id={`a_${id}`} />
      {(!mapcard && depthInfos.name) && (
        <p className={`${cls[`${mainCls}__depth`]} tp-w--s tp--up tp-a--r c-txt--f2`}>{depthInfos.name}</p>
      )}
      <Grid
        className={`${cls[mainCls]}${maplist ? ' maplist' : ''}${mapcard ? ' mapcard' : ''} b--s c-bg--w`}
        direction="column"
      >
        <CardContext.Provider value={cardContextValue}>
          {(!mapcard && poi) && (
            <Strip uri={uri} goToPDP={actions.goToPDP} className="c-bg--bg">
              {/* <>
                a <span className="tp-w--l">{poi.distance}m</span> dalla {poi.type === 'subway' ? 'metro ' : ''}<span className="tp-w--l">{poi.name}</span>
              </> */}
              {distancePoiStrip()}
            </Strip>
          )}
          {(!maplist && highlight) && (
            <Strip uri={uri} goToPDP={actions.goToPDP} className="c-bg--w bb--s">
              {highlight}
            </Strip>
          )}
          <Grid className={cls[`${mainCls}__inner`]}>
            {isFetching ? (
              <GalleryPlaceholder size={depthInfos.size} mapcard={mapcard} />
            ) : (
              <Gallery
                size={depthInfos.size}
                media={media}
                labels={labels}
                id={id}
                visible={visible}
                forceVisible={forceVisible}
                actions={actions}
                uri={uri}
                topRound={!poi && !highlight}
                botRound={!units}
                createFloorplanModal={createFloorplanModal}
                openModal={openModal}
                setCurrentFloorplan={setCurrentFloorplan}
                sendMail={sendMail}
                title={title}
                features={features}
                showMortgage={showMortgage}
                showMqPrice={showMqPrice}
                isProjectProfile={isProjectProfile}
                projectData={projectData}
                isAuction={isAuction}
                maplist={maplist}
                mapcard={mapcard}
                isMobile={isMobile}
                isHoliday={isHoliday}
              />
            )}
            <Details
              depthInfos={depthInfos}
              title={title}
              isAuction={isAuction}
              features={features}
              isProjectProfile={isProjectProfile}
              projectData={projectData}
              description={description}
              publisher={publisher}
              saved={saved}
              visible={visible}
              actions={actions}
              showMortgage={showMortgage}
              showMqPrice={showMqPrice}
              uri={uri}
              isHoliday={isHoliday}
              vWidth={vWidth}
              iosLth12={iosLth12}
            />
          </Grid>
          {(units && !mapcard) && (
            <Units
              data={units}
              title={title}
              goToPDP={actions.goToPDP}
            />
          )}
        </CardContext.Provider>
      </Grid>
    </div>
  );
}